import { render } from "./MCountdown.vue?vue&type=template&id=3579bab8&scoped=true&ts=true"
import script from "./MCountdown.vue?vue&type=script&lang=ts"
export * from "./MCountdown.vue?vue&type=script&lang=ts"

import "./MCountdown.vue?vue&type=style&index=0&id=3579bab8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3579bab8"]])

export default __exports__